import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  ActApprovalStepPayload,
  ApprovalRequestDetail,
  ApprovalRequestTableDto,
  ForwardApprovalRequestPayload,
} from '../../../models/approval/approval-request.model';

@Injectable({ providedIn: 'root' })
export class ApiApprovalRequestService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getApprovalRequestsForTable(
    userId: number,
    page = 1,
    pageSize = 20,
    inboxType?: string | null,
    status?: string | null,
    menuListId?: number | null,
    dateFrom?: string | null,
    dateTo?: string | null
  ): Observable<ApprovalRequestTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { userId, page, pageSize };
    if (inboxType) params['inboxType'] = inboxType;
    if (status) params['status'] = status;
    if (menuListId != null && menuListId > 0) params['menuListId'] = menuListId;
    if (dateFrom) params['dateFrom'] = dateFrom;
    if (dateTo) params['dateTo'] = dateTo;

    return this.apiMethodService.request<ApprovalRequestTableDto>(
      '/Approval/getApprovalRequestsForTable',
      'GET',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'getApprovalRequestsForTable', token, headerOnly: false, params }
    );
  }

  getApprovalRequestById(id: number, userId: number): Observable<ApprovalRequestDetail> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ApprovalRequestDetail>(
      '/Approval/getApprovalRequestById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getApprovalRequestById',
        token,
        headerOnly: false,
        params: { id, userId },
      }
    );
  }

  approveRequestStep(requestStepId: number, payload: ActApprovalStepPayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/Approval/approveRequestStep/${requestStepId}`,
      'PATCH',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'approveRequestStep', token, headerOnly: false, body: payload }
    );
  }

  rejectRequestStep(requestStepId: number, payload: ActApprovalStepPayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/Approval/rejectRequestStep/${requestStepId}`,
      'PATCH',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'rejectRequestStep', token, headerOnly: false, body: payload }
    );
  }

  forwardApprovalRequest(
    approvalRequestId: number,
    payload: ForwardApprovalRequestPayload
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/Approval/forwardApprovalRequest/${approvalRequestId}`,
      'POST',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'forwardApprovalRequest', token, headerOnly: false, body: payload }
    );
  }
}
